import { render, staticRenderFns } from "./DashboardOld.vue?vue&type=template&id=23f3b2b6&"
import script from "./DashboardOld.vue?vue&type=script&lang=js&"
export * from "./DashboardOld.vue?vue&type=script&lang=js&"
import style0 from "./DashboardOld.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports